import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, resource, role }) =>
    present(
      repository
        .saveResourceInProject(resource, project, role)
        .then((projectResource) => ({
          projectResource,
          resource,
          project,
          role,
        }))
        .catch(() => Promise.reject({ resource, project, role })),
    );
}

export type { Interactor };

export { createInteractor };
